import i18n from '@/utils/i18n';
import React from 'react';
import { AccountPickerList } from './account-picker-list';
import { Analytics } from '@/utils/analytics';
import { BaseActionSheet } from '@/components/base-action-sheet';
import { EmployeeRestaurant } from '@/contexts/user-context';
import { SCREEN_PADDING_SMALL } from '@/styles';
import { StyleSheet, useWindowDimensions } from 'react-native';
import { useOrderInboundDetailStore } from './store/order-inbound-detail-store';
import type { UnknownContactInfo } from './types';

export interface OrderInboundsDetailActionSheetProps {
  activeRestaurant: EmployeeRestaurant | null;
  isSmallLayout: boolean;
  marginTop: number;
  maxHeight: number;
  onClose: () => void;
  onSelectLocation: (restaurantRelationship: EmployeeRestaurant) => void;
  orderUUIDs: string[];
  setAssigningRestaurant: (restaurant: EmployeeRestaurant) => void;
  unknownContactInfo: UnknownContactInfo | null | undefined;
}

export const OrderInboundsDetailActionSheet: React.FC<
  OrderInboundsDetailActionSheetProps
> = ({
  activeRestaurant,
  isSmallLayout,
  marginTop,
  maxHeight,
  onClose,
  onSelectLocation,
  orderUUIDs,
  setAssigningRestaurant,
  unknownContactInfo,
}) => {
  const windowDimensions = useWindowDimensions();
  const updatingLocation = useOrderInboundDetailStore(
    (state) => state.updatingLocation,
  );

  const shouldShowActionSheet = updatingLocation;

  return (
    <BaseActionSheet
      avoidKeyboard
      contentStyle={[
        styles.actionSheetContent,
        isSmallLayout ? { marginTop } : { maxHeight },
      ]}
      isVisible={shouldShowActionSheet}
      modalHeaderStyle={styles.actionSheetModalHeader}
      modalStyle={[
        styles.actionSheetModal,
        { height: windowDimensions.height * 0.85 },
      ]}
      onClose={onClose}
      showToastsExternally
      title={i18n.t('accounts')}
    >
      <AccountPickerList
        activeRestaurantUUID={
          unknownContactInfo ? undefined : activeRestaurant?.uuid
        }
        onSelect={(restaurantRelationship) => {
          if (updatingLocation) {
            Analytics.track('order_inbound_detail.reassign_account', {
              newRestaurantUUID: restaurantRelationship.uuid,
              previousRestaurantUUID: activeRestaurant?.uuid,
              smartOrderUUIDs: orderUUIDs,
            });
            onSelectLocation(restaurantRelationship);
          } else {
            Analytics.track('order_inbound_detail.select_account_to_assign', {
              assigningToRestaurantUUID: restaurantRelationship.uuid,
              smartOrderUUIDs: orderUUIDs,
            });
            setAssigningRestaurant(restaurantRelationship);
            onClose();
          }
        }}
        skipInteractionCheck
      />
    </BaseActionSheet>
  );
};

const styles = StyleSheet.create({
  actionSheetContent: {
    flex: 1,
    paddingBottom: 0,
    paddingHorizontal: 0,
    paddingTop: SCREEN_PADDING_SMALL,
  },
  actionSheetModal: {
    maxWidth: 480,
  },
  actionSheetModalHeader: {
    paddingBottom: 0,
  },
});
